module.exports = __webpack_public_path__ + "media/images/writer/reservation/img-phone@2x-cb301ee301886c16a6b35051e281a91f.png";